<template>
  <div class="repartition-bar-horizontal">
    <div
      :class="{ 'flex-column': $vuetify.breakpoint.mobile }"
      class="repartition-bar-horizontal-legends"
    >
      <GraphLegend
        v-for="item of itemsForLegends"
        :key="item.code"
        :legend="item"
      />
    </div>

    <div
      :style="[dimensionStyles]"
      class="repartition-bar-horizontal-graph"
    >
      <div class="repartition-bar-horizontal-graph-list-item">
        <RepartitionBarItem
          v-for="item of items"
          :key="item.code"
          orientation="horizontal"
          :percentage="item.percentage"
          :color="item.color"
          :disabled="isItemDisabled(item)"
        >
          <RepartitionBarItemResume
            :visible="item.code === value"
            :item="item"
            :unit="unit"
            :positive-color="positiveColor"
            :negative-color="negativeColor"
            location="top"
            @updateVisibility="onUpdateResumeVisibility(item, $event)"
          />
        </RepartitionBarItem>
      </div>
    </div>
  </div>
</template>

<script>
import orderBy from 'lodash/orderBy'
import { PALETTE_REPARTITION, couleursPourEffectif } from '@/utils/palette-repartition'
import { convertToUnit } from 'vuetify/lib/util/helpers'
import GraphLegend from './graph-legend.vue'
import RepartitionBarItemResume from './repartition-bar-item-resume.vue'
import RepartitionBarItem from './repartition-bar-item.vue'
export default {
  name: 'RepartitionBarHorizontal',

  components: {
    RepartitionBarItemResume,
    GraphLegend,
    RepartitionBarItem
  },

  props: {
    value: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      required: true
    },
    unit: {
      type: String,
      default: null
    },
    width: {
      type: [String, Number],
      default: '100%'
    },
    height: {
      type: [String, Number],
      default: 96
    },
    positiveColor: {
      type: String,
      default: '#01713C'
    },
    negativeColor: {
      type: String,
      default: 'warning'
    },
    palette: {
      type: Array,
      default: () => PALETTE_REPARTITION
    }
  },

  emits: ['input'],

  data () {
    return {
      selectedCode: null
    }
  },

  computed: {
    items () {
      return this.data.items.map((item, index) => ({
        ...item,
        color: item.color != null ? item.color : this.colors[index]
      }))
    },

    itemsForLegends () {
      return orderBy(this.items, 'percentage', 'desc').slice(0, 3)
    },
    dimensionStyles () {
      return {
        width: convertToUnit(this.width),
        height: convertToUnit(this.height)
      }
    },
    colors () {
      return couleursPourEffectif(this.data.items.length, this.palette)
    }
  },

  methods: {
    isItemDisabled (item) {
      return this.value != null && this.value !== item.code
    },

    onUpdateResumeVisibility (item, visible) {
      let selectedCode
      if (visible) {
        selectedCode = item.code
      } else {
        if (this.value === item.code) {
          selectedCode = null
        }
      }

      this.$emit('input', selectedCode)
    }
  }
}
</script>

<style lang="scss" scoped>
.repartition-bar-horizontal {
  .repartition-bar-horizontal-legends {
    display: flex;
    gap: 16px;
    margin-bottom: 22px;
  }

  .repartition-bar-horizontal-graph {
    padding: 12px;
    border-radius: 16px;
    box-shadow:
      0 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)),
      0 2px 2px 0 var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)),
      0 1px 5px 0 var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
    background-color: #ffffff;

    .repartition-bar-horizontal-graph-list-item {
      display: flex;
      gap: 1px;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
</style>
